import { render, staticRenderFns } from "./RepetitionSessionFinishedDialog.vue?vue&type=template&id=ff8d36d4&"
import script from "./RepetitionSessionFinishedDialog.vue?vue&type=script&lang=ts&"
export * from "./RepetitionSessionFinishedDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports